// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"641":"0ee3bae3","879":"6da337ac"}[chunkId] + ".chunk.js";
};